















import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import { authService } from '@/service/firebase'

@Component( {
    computed: mapGetters( {
        signInEmail: 'usersModule/signInEmail',
        currentUser: 'usersModule/currentUser'
    } )
} )
export default class WelcomeView extends Vue {
    loginSuccess = false
    isNewUser = false
    signInEmail!: any

    startExploration() {
        this.$router.push( { name: 'Explorer' } )
    }

    created() {
        const url = window.location.href

        if ( authService.isSignInWithEmailLink( url ) && this.signInEmail ) {
            // this.signingIn = true

            authService.signInWithEmailLink( this.signInEmail, url )
                .then( ( result ) => {
                    this.loginSuccess = true
                    window.localStorage.removeItem( 'userEmail' )

                    if ( result && result.additionalUserInfo ) {
                        this.isNewUser = result.additionalUserInfo.isNewUser
                    }
                } )
        } else {
            // this.signingIn = false
        }
    }
}
